import { useEffect } from 'react';
import { Insets } from './useKron';

export const useInsetCssVariables = (insets?: Insets) => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const root = document.documentElement;
    const insetTop = `${insets?.top ?? 0}px`;
    const insetRight = `${insets?.right ?? 0}px`;
    const insetBottom = `${insets?.bottom ?? 0}px`;
    const insetLeft = `${insets?.left ?? 0}px`;
    const hasModalInsets = (insets?.top ?? 0) > 0 || (insets?.bottom ?? 0) > 0;
    const modalMaxHeight = hasModalInsets
      ? `calc(100vh - ${insets?.top ?? 0}px - ${insets?.bottom ?? 0}px)`
      : 'calc(100vh - 2rem)';

    root.style.setProperty('--inset-top', insetTop);
    root.style.setProperty('--inset-right', insetRight);
    root.style.setProperty('--inset-bottom', insetBottom);
    root.style.setProperty('--inset-left', insetLeft);
    root.style.setProperty('--modal-max-height', modalMaxHeight);

    return () => {
      root.style.removeProperty('--inset-top');
      root.style.removeProperty('--inset-right');
      root.style.removeProperty('--inset-bottom');
      root.style.removeProperty('--inset-left');
      root.style.removeProperty('--modal-max-height');
    };
  }, [insets?.top, insets?.right, insets?.bottom, insets?.left]);
};
